import { SeverityNumber, } from '@opentelemetry/api-logs';
export var LogLevel;
(function (LogLevel) {
    LogLevel["ERROR"] = "ERROR";
    LogLevel["WARN"] = "WARN";
    LogLevel["INFO"] = "INFO";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["TRACE"] = "TRACE";
    LogLevel["FATAL"] = "FATAL";
    LogLevel["UNSPECIFIED"] = "UNSPECIFIED";
})(LogLevel || (LogLevel = {}));
export { SeverityNumber };
export { ValueType } from '@opentelemetry/api';
export { Tracer } from '@opentelemetry/sdk-trace-base';
//# sourceMappingURL=types.js.map